import React from "react";
import { AlertTriangle, AlertCircle, Info, ShieldCheck } from "lucide-react";
import { format } from "date-fns";

const ICONS = { high: AlertTriangle, medium: AlertCircle, low: Info };
const COLORS = {
  high:   "border-red-500/40 bg-red-500/10 text-red-200",
  medium: "border-amber-500/40 bg-amber-500/10 text-amber-200",
  low:    "border-sky-500/40 bg-sky-500/10 text-sky-200",
};

export default function AlertsPanel({ alerts, ts }) {
  return (
    <section className="panel p-5 h-full" data-testid="alerts-panel">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-base tracking-tight">ALERTS</h3>
        <div className="label-tech">
          {alerts?.length || 0} active
          {ts ? <span className="ml-2 text-zinc-500">· { (() => { try { return format(new Date(ts), "HH:mm:ss"); } catch { return ""; } })() }</span> : null}
        </div>
      </div>
      {(!alerts || alerts.length === 0) ? (
        <div className="flex items-center gap-3 p-4 border border-emerald-500/30 bg-emerald-500/5 rounded-sm" data-testid="alerts-empty">
          <ShieldCheck className="w-4 h-4 text-emerald-400" />
          <div>
            <div className="text-sm text-emerald-300 font-medium">All systems nominal</div>
            <div className="label-tech text-[10px] mt-0.5">No threshold breaches detected</div>
          </div>
        </div>
      ) : (
        <ul className="space-y-2 max-h-[320px] overflow-y-auto pr-1">
          {alerts.map((a, idx) => {
            const Icon = ICONS[a.severity] || Info;
            return (
              <li
                key={`${a.code}-${idx}`}
                className={`flex items-start gap-3 px-3 py-2 border rounded-sm ${COLORS[a.severity] || COLORS.low}`}
                data-testid={`alert-item-${idx}`}
              >
                <Icon className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-white">{a.message}</div>
                  <div className="label-tech text-[10px] mt-1 flex items-center gap-2 flex-wrap">
                    <span>{a.code} · value {Number(a.value).toFixed(2)}</span>
                    <span className="text-zinc-500">·  threshold {Number(a.threshold).toFixed(2)}</span>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
